import { useFormik } from "formik";
import React, { useEffect } from "react";
import { useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import MoreDocument from "../../modals/customers/create/MoreDocument";
import * as yup from "yup";
import { flashMessage as flash } from "./../../../utils/flash/index";
import { useDispatch, useSelector } from "react-redux";
import useFileUpload from "../../../utils/hooks/useFileUpload";
import {
  addCorporateCustomer,
  resetCustomerStatus,
} from "../../../redux/slice/customer/customerSlice";
import { useLocation } from "react-router-dom";
import { useRef } from "react";
import Success from "../../../pages/admin/customer/Success";

const Identification = () => {
  const fileTypes = ["JPG", "PNG", "JPEG", "PDF", "DOC", "DOCX"];
  const { offices } = useSelector((state) => state.office);
  const [selectedFile, setSelectedFile] = useState("");
  const { fileUrl, singleFileUpload } = useFileUpload();
  const [businessDocuments, setBusinessDocuments] = useState({});
  const [isUploading, setIsUploading] = useState(false);
  const { application_info, isSuccess } = useSelector(
    (state) => state.customer
  );
  const { user } = useSelector((state) => state.auth);

  // other_document_name, other_document_url
  let successRef = useRef();

  const dispatch = useDispatch();
  const location = useLocation();

  const onSubmit = (values, actions) => {
    // if (values.identity_type != "national_id") {
    //   if (values.date_of_insurance.length == 0) {
    //     flash("error", "please enter date of issuance");
    //     return;
    //   }
    //   if (values.date_of_expiration.length == 0) {
    //     flash("error", "please enter date of expiration");
    //     return;
    //   }
    // }
    // if (
    //   !businessDocuments?.document_url ||
    //   !businessDocuments?.sla_url ||
    //   !businessDocuments?.cert_incorp_url
    // ) {
    //   flash("error", "please upload required documents");
    //   return;
    // }
    const payload = {
      ...application_info,
      ...values,
      ...businessDocuments,
      ...businessDocuments,
      staff_id: user?.user?.staff_id,
    };
    // console.log(payload);

    dispatch(addCorporateCustomer(payload));
  };

  const handleFileChange = (file) => {
    setIsUploading(true);
    singleFileUpload(file);
  };

  const IdentificationSchema = yup.object().shape({
    identity_type: yup.string().required("please choose identification type"),
    identity_number: yup
      .number()
      .integer()
      .positive()
      .required("please enter identification number"),
    branch_id: yup.string().required("please choose branch"),
    date_of_insurance: yup.date(),
  });

  const { values, errors, handleBlur, touched, handleChange, handleSubmit } =
    useFormik({
      initialValues: {
        identity_type: "",
        date_of_insurance: "",
        date_of_expiration: "",
        identity_number: "",
        document_url: "",
        cert_incorp_url: "",
        sla_url: "",
        branch_id: user?.user?.office_id || "",
      },
      // validationSchema: IdentificationSchema,
      onSubmit,
    });

  useEffect(() => {
    if (fileUrl) {
      setIsUploading(false);
      setBusinessDocuments({ ...businessDocuments, [selectedFile]: fileUrl });
    }
  }, [fileUrl]);

  useEffect(() => {
    if (isSuccess) {
      successRef.current.click();
      dispatch(resetCustomerStatus());
    }
  }, [isSuccess]);

  return (
    <div className="border border-top-0 px-3">
      <form onSubmit={handleSubmit}>
        <div className="row mb-2">
          <div className="mb-0 mt-3 col-md-4">
            <label
              htmlFor="inputEmail4"
              className="form-label d-flex align-baseline"
            >
              <span>Identification type</span>
              {/* <span className='text-danger'>*</span> */}
            </label>
            <select
              textname="means of identification"
              name="identity_type"
              onChange={handleChange}
              value={values.identity_type}
              onBlur={handleBlur}
              type="date"
              id="identity_type"
              className={`form-select ${
                errors.identity_type && touched.identity_type && "is-invalid"
              }`}
            >
              <option value="">-- Select --</option>
              <option value="drivers_license">Drivers License</option>
              <option value="national_id">National ID Card</option>
              <option value="passport">National Passport</option>
              <option value="voters_card">Voter's Card</option>
            </select>
            {errors.identity_type && touched.identity_type && (
              <span className="invalid-feedback">{errors.identity_type}</span>
            )}
          </div>
          {values.identity_type !== "national_id" && (
            <div className="mb-0 mt-3 col-md-4">
              <label htmlFor="inputEmail4" className="form-label">
                Date of Issuance
                {/* <span className='text-danger'>*</span> */}
              </label>
              <input
                type="date"
                name="date_of_insurance"
                id="date_of_insurance"
                onChange={handleChange}
                value={values.date_of_insurance}
                onBlur={handleBlur}
                className={`form-control ${
                  errors.date_of_insurance &&
                  touched.date_of_insurance &&
                  "is-invalid"
                }`}
              />
              {errors.date_of_insurance && touched.date_of_insurance && (
                <span className="invalid-feedback">
                  {errors.date_of_insurance}
                </span>
              )}
            </div>
          )}
          {values.identity_type !== "national_id" && (
            <div className="mb-0 mt-3 col-md-4">
              <label htmlFor="inputEmail4" className="form-label">
                Date of Expiry
                {/* <span className='text-danger'>*</span> */}
              </label>
              <input
                type="date"
                textname="date of expiry"
                name="date_of_expiration"
                onChange={handleChange}
                value={values.date_of_expiration}
                id="date_of_expiration"
                className={`form-control ${
                  errors.date_of_expiration && "is-invalid"
                }`}
              />
              {errors.date_of_expiration && (
                <span className="invalid-feedback">
                  {errors.date_of_expiration}
                </span>
              )}
            </div>
          )}

          <div className="mb-0 mt-3 col-md-4">
            <label
              htmlFor="inputEmail4"
              className="form-label d-flex align-baseline"
            >
              <span>Identification Number</span>
              {/* <span className='text-danger'>*</span> */}
            </label>
            <input
              type="number"
              name="identity_number"
              id="identity_number"
              onChange={handleChange}
              value={values.identity_number}
              onBlur={handleBlur}
              className={`form-control ${
                errors.identity_number &&
                touched.identity_number &&
                "is-invalid"
              }`}
              placeholder="ID No."
            />
            {errors.identity_number && touched.identity_number && (
              <span className="invalid-feedback">{errors.identity_number}</span>
            )}
          </div>

          <div className="col-md-4 mt-3">
            <label htmlFor="inputEmail4" className="form-label d-block">
              Upload ID
              {/* <span className='text-danger'>*</span> */}
              {selectedFile == "document_url" &&
                isUploading &&
                !businessDocuments.document_url && (
                  <span>
                    {" "}
                    <i className="mdi mdi-dots-circle mdi-spin"></i>{" "}
                  </span>
                )}
              {businessDocuments.document_url && (
                <span>
                  <i className="mdi mdi-check"></i>
                </span>
              )}
            </label>
            <FileUploader
              label=" Browse Document"
              children={
                <div
                  className="borde border-dotted p-1 px-4 text-center cursor-p"
                  style={{ border: "2px dashed grey" }}
                  onClick={() => setSelectedFile("document_url")}
                  // onDrop={handleFileChange}
                >
                  <i className="uil uil-cloud-upload fs-4"></i> Upload Document
                  <span className="text-primary-dark mt-0"></span>
                </div>
              }
              handleChange={handleFileChange}
              // onDrop={() => {
              //   setSelectedFile('document_url')
              //   handleFileChange()
              // }}
              name="document_url"
              types={fileTypes}
            />
          </div>

          <div className="col-md-4 mt-3">
            <label htmlFor="inputEmail4" className="form-label d-block">
              <span>Service Level Agreement (SLA)</span>
              {/* <span className='text-danger'>*</span> */}
              {selectedFile == "sla_url" &&
                isUploading &&
                !businessDocuments.sla_url && (
                  <span>
                    {" "}
                    <i className="mdi mdi-dots-circle mdi-spin"></i>{" "}
                  </span>
                )}
              {businessDocuments.sla_url && (
                <span>
                  <i className="mdi mdi-check"></i>
                </span>
              )}
            </label>
            <FileUploader
              label=" Browse Document"
              children={
                <div
                  className="borde border-dotted p-1 px-4 text-center cursor-p"
                  style={{ border: "2px dashed grey" }}
                  onClick={() => setSelectedFile("sla_url")}
                >
                  <i className="uil uil-cloud-upload fs-4"></i> Upload Document
                  <span className="text-primary-dark mt-0"></span>
                </div>
              }
              handleChange={handleFileChange}
              // onDrop={handleChange}
              name="file"
              types={fileTypes}
            />
          </div>

          <div className="row">
            <div className="col-md-4 mt-3">
              <label htmlFor="inputEmail4" className="form-label d-block">
                <span>Certificate of Incorporation </span>
                {/* <span className='text-danger'>*</span> */}
                {selectedFile == "cert_incorp_url" &&
                  isUploading &&
                  !businessDocuments.cert_incorp_url && (
                    <span>
                      {" "}
                      <i className="mdi mdi-dots-circle mdi-spin"></i>{" "}
                    </span>
                  )}
                {businessDocuments.cert_incorp_url && (
                  <span>
                    <i className="mdi mdi-check"></i>
                  </span>
                )}
              </label>
              <FileUploader
                label=" Browse Document"
                children={
                  <div
                    className="borde border-dotted p-1 px-4 text-center cursor-p"
                    style={{ border: "2px dashed grey" }}
                    onClick={() => setSelectedFile("cert_incorp_url")}
                  >
                    {" "}
                    <i className="uil uil-cloud-upload fs-4"></i> Upload
                    Document
                    <span className="text-primary-dark mt-0"></span>
                  </div>
                }
                handleChange={handleFileChange}
                // onDrop={handleChange}
                name="file"
                types={fileTypes}
              />
            </div>
            {/* <div className='mb-0 mt-3 col-md-6'>
              <label
                htmlFor='inputEmail4'
                className='form-label d-flex align-baseline'
              >
                <span>Branch</span>
                
              </label>
              <select
                id='branch_id'
                name='branch_id'
                onChange={handleChange}
                value={values.branch_id}
                onBlur={handleBlur}
                className={`form-select ${
                  errors.branch_id && touched.branch_id && "is-invalid"
                }`}
              >
                <option value=''>-- Select Branch --</option>
                {offices?.offices?.map(({ office_name, id }) => (
                  <option key={id} value={id}>
                    {office_name}
                  </option>
                ))}
              </select>
              {errors.branch_id && touched.branch_id && (
                <span className='invalid-feedback'>{errors.branch_id}</span>
              )}
            </div> */}
          </div>
        </div>
        <a
          className="btn btn-secondary mb-3 mt-2"
          data-bs-toggle="modal"
          data-bs-target="#more_document_modal"
        >
          Add More Document
        </a>
        <div className="d-flex justify-content-end mb-3">
          <button type="submit" className="btn btn-primary-1 text-white">
            Submit
          </button>
          <a
            href="#"
            data-bs-toggle="modal"
            data-bs-target="#create_customer_step_1"
            ref={successRef}
            className="invisible"
          >
            success
          </a>
        </div>
      </form>
      <Success modal_id="create_customer_step_1" />
      <MoreDocument modal_id="more_document_modal" modal_width="modal-lg" />
    </div>
  );
};

export default Identification;
